export default __webpack_public_path__ + "locales/ar-SA/DeleteThirdPartyDialog.json?hash=5ecb5dd69ff5ab513e0175bfa6fe3971";